import React from 'react';
import { PrintImage } from '../../../../../assets/images';
import { ImageTextLink } from '../../imageTextLink';
import { TextLink } from '../../textLink';
import { ImageAlignment } from '../../../../../models';

interface PrintLinkProps {
  includeImage?: boolean;
}

const printCaption = 'Print';

const PrintLink: React.FC<PrintLinkProps> = (props: PrintLinkProps) => {
  const onButtonClicked = () => {
    window.print();
  };

  return (
    <>
      {props.includeImage === undefined || props.includeImage ? (
        <ImageTextLink
          imageSource={PrintImage}
          caption={printCaption}
          onClick={onButtonClicked}
          imageAlignment={ImageAlignment.Left}
          allowWrap={false}
        />
      ) : (
        <TextLink caption={printCaption} onClick={onButtonClicked} />
      )}
    </>
  );
};

export default PrintLink;
